import React, { memo, useEffect, useState } from 'react';

import { Lottie } from '@uncinc/uncinc-react-kitchen-sink';

interface LottieInlineProps {
  url: string;
  lottieId?: string;
  ariaLabel?: string;
}

const LottieInline = memo(({
  url,
  lottieId,
  ariaLabel,
}: LottieInlineProps) => {
  const [json, setJson] = useState<string | null>(null);

  useEffect(() => {
    fetch(url)
      .then((res) => res.text())
      .then(setJson)
      .catch(() => {});
  }, [url]);

  if (!json) {
    return null;
  }

  return (
    <Lottie
      id={lottieId}
      data={JSON.parse(json) as unknown}
      autoPlay
      loop
      ariaLabel={ariaLabel ?? ''}
    />
  );
});

export default LottieInline;
